import { Box } from '@mui/material'
import { type FC, type ReactNode } from 'react'
import { Error, type IChipProps, type IDropdownItem, type IDropdownProps } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type ILabelProps, Label } from 'shared/ui/Label'
import type { SelectMultiListDisplayMode } from 'shared/ui/Select/SelectMultiList/constants'
import styles from '../styles.module.scss'
import { SelectMultiList } from '../SelectMultiList/SelectMultiList'

export type SelectFieldMultiListProps = {
  labelText?: string
  labelProps?: ILabelProps
  selectedItems?: IDropdownItem[]
  items: IDropdownItem[]
  onDelete?: (item: IDropdownItem) => void
  onSelect?: (item: IDropdownItem) => void
  error?: ReactNode
  fullWidth?: boolean
  labelGap?: string
  dropdownProps?: IDropdownProps
  ChipComponent?: FC<IChipProps>
  withInitialSearch?: boolean
  initialSearchPlaceholder?: string
  customComponent?: IDropdownProps['customComponent']
  maxVisibleChips?: number
  maxChipsHeight?: number
  placeholderClassName?: string
  displayMode?: SelectMultiListDisplayMode
}

export const SelectFieldMultiList = ({
  labelText = '',
  labelProps,
  selectedItems = [],
  items,
  onDelete,
  onSelect,
  error,
  fullWidth = false,
  labelGap = '4px',
  dropdownProps,
  ChipComponent,
  withInitialSearch,
  initialSearchPlaceholder,
  customComponent,
  maxVisibleChips,
  maxChipsHeight,
  placeholderClassName,
  displayMode,
}: SelectFieldMultiListProps) => {
  return (
    <Box
      display='grid'
      gap={labelGap}
      aria-label={getAriaLabel(`SelectFieldMultiList ${labelText}`)}
      className={fullWidth ? styles.fullWidth : undefined}
    >
      {(labelText || labelProps) && (
        <Label
          label={{
            text: labelText,
          }}
          {...labelProps}
        />
      )}
      <SelectMultiList
        type='multiList'
        text='Select'
        items={items}
        selectedItems={selectedItems}
        onDelete={onDelete}
        onSelect={onSelect}
        fullWidth={fullWidth}
        dropdownProps={dropdownProps}
        ChipComponent={ChipComponent}
        withInitialSearch={withInitialSearch}
        {...(initialSearchPlaceholder ? { initialSearchPlaceholder } : {})}
        customComponent={customComponent}
        error={error}
        maxVisibleChips={maxVisibleChips}
        maxChipsHeight={maxChipsHeight}
        placeholderClassName={placeholderClassName}
        displayMode={displayMode}
      />
      {error && <Error type='text' error={error} />}
    </Box>
  )
}
